import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./About.module.css";
import image1 from "../../assets/gallery/constructions/District Secratarial Building - Polonnaruwa/1.jpg";
import image2 from "../../assets/gallery/constructions/District Secratarial Building - Matale/2.jpg";
// Company values data
const values = [
  {
    icon: "🏛️",
    title: "Heritage Craftsmanship",
    description: "We preserve centuries-old stone masonry traditions while embracing modern precision techniques."
  },
  {
    icon: "💎",
    title: "Distinguished Quality",
    description: "Only the finest natural stones are selected for our works, sourced from prestigious quarries worldwide."
  },
  {
    icon: "🔨",
    title: "Artisanal Excellence",
    description: "Our master stonemasons combine traditional methods with contemporary innovations to create enduring structures."
  },
  {
    icon: "🌿",
    title: "Noble Sustainability",
    description: "We maintain environmentally responsible practices in our quarrying and construction processes."
  }
];



const About = () => {
  const navigate = useNavigate();
  
  return (
    <div className={styles.about}>
      <div className={styles.header}>
        <h1>The Throne Stone Legacy</h1>
        <p>
          Welcome to Throne Stone, Sri Lanka’s trusted name in the natural stone industry since 2000. With over two decades of expertise, we have established ourselves as the leading professionals in fair face rubble and custom stone craftsmanship.
At Throne Stone, we transform natural stone into timeless works of art, tailored to your vision. Whether it's interior or exterior, residential or commercial, we take pride in delivering high-quality stonework that blends beauty with durability.
We are committed to exceeding your expectations, offering a 5-year warranty on all our work as a testament to our quality and reliability. Your dream is our blueprint — and we are here to bring it to life with precision, passion, and professionalism.
        </p>
      </div>
      
      <div className={styles.aboutContent}>
        <div className={styles.aboutSection}>
          <div className={styles.aboutText}>
            <h2>Our Services</h2>
            <p>
At Throne Stone, we specialize in a wide range of custom stone solutions for both interior and exterior applications. Our services include:
Floor and Wall Designs – From elegant patterns to bold statement pieces, we craft all types of stone designs tailored to your space and style.
Fair Face Rubble Work – Expertly finished natural stone surfaces that combine strength with aesthetic appeal.
Custom Stone Artwork – Unique, handcrafted stone features that bring your vision to life.
Residential & Commercial Projects – No matter the scale, we handle every project with precision and care.
Whether you're upgrading a home, building a commercial space, or adding a special feature, Throne Stone is here to deliver lasting beauty with unmatched craftsmanship.
            </p>
          
          </div>
          <div className={styles.aboutImg}>
            <img src={image1} alt="Throne Stone Heritage" />
          </div>
        </div>
        
        <div className={`${styles.aboutSection} ${styles.reversed}`}>
          <div className={styles.aboutText}>
            <h2>Our Distinguished Process</h2>
            <p>
              At Throne Stone, we firmly believe that exceptional stonework begins with materials of the highest 
              caliber. We meticulously select the finest stones from both venerable local quarries and prestigious 
              international sources, ensuring each piece meets our exacting standards for quality and beauty.
            </p>
            <p>
              Our master craftsmen then transform these noble materials into architectural elements 
              of distinction, combining centuries-old techniques with modern precision. From initial concept to 
              final realization, we collaborate closely with our esteemed clients to manifest their vision while 
              upholding the highest standards of traditional craftsmanship.
            </p>
          </div>
          <div className={styles.aboutImg}>
            <img src={image2} alt="Our Stone Process" />
          </div>
        </div>
      </div>
      
      <div className={styles.values}>
        <h2>Our Noble Principles</h2>
        <div className={styles.valuesGrid}>
          {values.map((value, index) => (
            <div 
              key={index} 
              className={styles.valueCard}
              style={{ '--index': index }}
            >
              <div className={styles.valueIcon}>
                {value.icon}
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.ctaSection}>
        <h2>Commission Your Masterpiece</h2>
        <p>
          Whether you envision a stately residential feature, a distinguished commercial edifice, or a lasting public monument, 
          Throne Stone stands prepared to realize your vision with exceptional craftsmanship and the world's 
          most prestigious stone materials.
        </p>
        <button 
          className={styles.ctaButton}
          onClick={() => navigate("/contact")}
        >
          Request Consultation
        </button>
      </div>
    </div>
  );
};

export default About;